import { Component, Input, ElementRef, OnChanges, OnDestroy } from '@angular/core';

import { HtmlService } from '../../../../../../services/html.service';

declare var TextHighlighter: any;

@Component({
    selector: 'html-resource',
    template: require('./html-resource.component.html'),
})
export class HtmlResourceComponent implements OnChanges, OnDestroy {
    @Input() id: number;
    html: string;
    highlighter: any;

    constructor(private htmlService: HtmlService, private elemRef: ElementRef) {
        this.elemRef = elemRef;
    }

    ngOnChanges() {
        this.htmlService.getHtmlResource(this.id).subscribe(x => {
            this.html = x
            this.initHighlighter();
            const previousHighlights = this.htmlService.getSerializedHighlights(this.id);
            if (previousHighlights) {
                setTimeout(() => {
                    this.highlighter.deserializeHighlights(previousHighlights.HighlightedText);
                }, 500);
            }
        });
    }

    ngOnDestroy() {
        if(this.highlighter){
            this.highlighter.destroy();
        }       
    }

    initHighlighter() {
        if (this.highlighter) {
            this.highlighter.destroy();
        }
        const sandbox = this.elemRef.nativeElement;
        this.highlighter = new TextHighlighter(sandbox, {
            onBeforeHighlight: (range) => {
                if (range) {
                    // wait for commonAncestorContainer to be initialised
                    setTimeout(() => {
                        if (range.commonAncestorContainer.className === "highlighted") {
                            if (range.endContainer.data && range.endContainer.data.trim() == "") {
                                return false;
                            }
                            this.highlighter.removeHighlights(range.commonAncestorContainer);
                            return false;
                        }
                    }, 100);
                    return true;
                }
            },
            onAfterHighlight: (range, hlts) => {
                // update state: save highlights (triggered on remove as well)
                // 0.5s delay to allow highlighter to refresh currently highlighted text
                setTimeout(() => {
                    const dto: PgRendererDto.HighlightDto = {
                        ResourceId: this.id,
                        HighlightedText: this.highlighter.serializeHighlights()
                    }
                    this.htmlService.setSerializedHighlights(dto);
                }, 500);
            }
        });
        this.highlighter.setColor('#FFFF7B');
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/html-resource/html-resource.component.ts